import { AppointmentEncounterMode, BookingChannel } from '@dreryk/egabinet-appointment-frontend-api';

import { getDocplannerAvailabilityLabel, getPatientPortalAvailabilityLabel } from '~libs.shared.appointments';

import { RecurrencePeriod } from '../common/common.types';
import { EncounterModeValue } from '../common/fields/EncounterMode/EncounterModeCheckboxes.types';

export const setRecurrencePeriodRadioValue = (recurrencePeriodInWeeks: number | undefined): RecurrencePeriod => {
   switch (recurrencePeriodInWeeks) {
      case 1:
         return RecurrencePeriod.EVERY_WEEK;
      case 2:
         return RecurrencePeriod.EVERY_TWO_WEEKS;
      default:
         return RecurrencePeriod.NONE;
   }
};

type SetBookingChannelsReturnFn = {
   docplannerEncounterMode: EncounterModeValue | null;
   patientPortalEncounterMode: EncounterModeValue | null;
};

export const setBookingChannels = (bookingChannels: BookingChannel[] | undefined): SetBookingChannelsReturnFn => {
   if (!Array.isArray(bookingChannels)) {
      return { docplannerEncounterMode: null, patientPortalEncounterMode: null };
   }

   const getEncounterMode = (encounterModes: AppointmentEncounterMode[]): EncounterModeValue => {
      return encounterModes.length === 0
         ? { onSite: true, videoConsultation: true }
         : {
              onSite: encounterModes.includes('ON_SITE'),
              videoConsultation: encounterModes.includes('VIDEO_CONSULTATION'),
           };
   };

   return bookingChannels.reduce<SetBookingChannelsReturnFn>(
      (acc, { label, encounterModes }) => {
         if (label === getDocplannerAvailabilityLabel()) {
            acc.docplannerEncounterMode = getEncounterMode(encounterModes);
         }

         if (label === getPatientPortalAvailabilityLabel()) {
            acc.patientPortalEncounterMode = getEncounterMode(encounterModes);
         }

         return acc;
      },
      { docplannerEncounterMode: null, patientPortalEncounterMode: null }
   );
};
